<!-- Ecommerce Item -->
<div class="row new-members-box">
  <div class="col-8">
    <p style="margin-top: 10px;">Accept New Members</p>
  </div>
  <div class="col-4">
    <div class="custom-control custom-switch">
      <input
        type="checkbox"
        class="custom-control-input"
        (click)="changeStatus(product.status)"
        id="statusSwitch{{ product.id }}"
        [checked]="product.status == 'active'"
      />
      <label class="custom-control-label" for="statusSwitch{{ product.id }}" style="margin-top: 10px;">
        <span class="switch-icon-left"><i data-feather="check"></i></span>
        <span class="switch-icon-right"><i data-feather="x"></i></span>
      </label>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <a
      class="text-body"
      [routerLink]="['/apps/member/member-list']"
    >
      <b>{{ product.memberCounter }}</b> members</a
    >
  </div>
</div>
<!-- <div class="item-img text-center">
  <a style="cursor:default;">
    <img class="img-fluid card-img-top" [src]="product.image" alt="img-placeholder" />
  </a>
</div> -->
<div style="min-height: 100px;">
  <div class="card-body plan-body">
    <h6 class="item-name">
      <a class="text-body" style="cursor: default"> {{ product.title }}</a>
      <br />
      <a
        [routerLink]="'/apps/e-commerce/details/' + product.group"
        class="company-name"
        >{{ product.group }}</a
      >
    </h6>
    <!-- <p class="card-text item-description">
      {{ product.description }}
    </p> -->
  </div>
  <div class="item-options text-center">
    <div class="item-wrapper row">
      <!-- <div class="item-cost col-4">
        <h6>ANNUALLY</h6>
        <h5 class="item-price">${{ product.price.annual.toFixed(2) }}<small>/yr</small></h5>
      </div>
      <div class="item-cost col-4">
        <h6>MONTHLY</h6>
        <h5 class="item-price">${{ product.price.monthly.toFixed(2) }}<small>/mo</small></h5>
      </div> -->
      <div class="item-cost col-12">
        <!-- <h6>WEEKLY</h6> -->
        <h5 class="item-price">
          ${{ product.pricing.weekly.toFixed(2) }}<small>/Week</small>
        </h5>
      </div>
    </div>
  </div>
  <div class="benefits">
    <ul>
      <div *ngFor="let treatment of product.treatment; let i = index">
        <li  *ngIf="treatment.annualQuantity!=0">
          <i data-feather="check"></i>
            {{ treatment.annualQuantity }}x {{ treatment.title }}
        </li>
        <li  *ngIf="treatment.annualQuantity==0">
          <i data-feather="check"></i>
            {{ treatment.title }}
        </li>
      </div>
    </ul>
  </div>
  <div class="item-options text-center" style="margin: 10px">
    <button
      type="submit"
      *ngIf="!loadingButton"
      class="btn btn-primary mr-1"
      (click)="openItem(product.id)"
      rippleEffect
    >
      <i data-feather="edit" class="mr-25"></i> Edit
    </button>
  
    <button
      class="btn btn-outline-primary"
      *ngIf="loadingButton"
      type="button"
      disabled
      rippleEffect
    >
      <span
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
      <span class="ml-25 align-middle">Saving...</span>
    </button>
  </div>
</div>
<!-- [routerLink]="'/apps/e-commerce/details/' + product.id" -->
<!--/ Ecommerce Item -->
